import { HttpClient } from '@angular/common/http';
import { LoganApiConfig } from '../models/services.model';
import { LoganApiService } from './api.service';
import { environment } from 'src/environments/environment';

export abstract class LoganService extends LoganApiService {
  constructor(http: HttpClient, module: string) {
    super(http, new LoganApiConfig(environment.loganConfig), module);
  }
}
